import React from "react";
function Footer(){
    return(
        <footer className="footer-one">
        <div className="footer-top">
            <div className="container">
                <div className="d-sm-flex justify-content-between align-items-center">
                    <div className="footer-logo mb-xs-gap-30">
                         <img src="assets/img/logomainwhite.png" alt="Image"/>
                    </div>
                    <ul className="social-icon">
                        <li><a href="https://www.facebook.com/profile.php?id=61573033526358"><i className="fab fa-facebook-f"></i> </a></li>
                        <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                        <li><a href="#"><i className="fab fa-youtube"></i> </a></li>
                        <li><a href="https://www.instagram.com/aa_digitals_marketing/"><i className="fab fa-instagram"></i> </a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="footer-widgets">
            <div className="container">
                <div className="row">
                    <div className="col-xl-4 col-md-6">
                        <div className="widget about-widget">
                            <h5 className="widget-title">About us.</h5>
                            <p>
                                Enjoy exceptional service from our skilled team focused on delivering top-notch results. We strive to surpass your expectations with our knowledge and meticulous approach. Count on us to enhance your project with accuracy and creativity, ensuring a smooth and impressive outcome.
                            </p>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="widget nav-widget">
                            <h5 className="widget-title">Services.</h5>
                            <ul>
                                <li><a href="#">Branding</a></li>
                                <li><a href="#">Social media handling</a></li>
                                <li><a href="#">Web Development</a></li>
                                <li><a href="#">SEO</a></li>
                                <li><a href="#">Graphical Designing</a></li>
                                <li><a href="#">Logo Creation</a></li>
                            </ul>
                        </div>
                    </div>
                   
                    <div className="col-xl-4 col-md-6">
                        <div className="widget contact-info">
                            <h5 className="widget-title">Get in touch.</h5>
                            <ul>
                                <li>
                                    <i className="fal fa-map-marker-alt"></i>
                                    <span>Office:</span> No 10, 80 Feet Road, Sathya Garden, Saligramam, Chennai - 600093
                                </li>
                                <li>
                                    <i className="fal fa-phone"></i>
                                    <span>Phone:</span> 6381643312 / 9790755708
                                </li>
                                <li>
                                    <i className="fal fa-envelope"></i>
                                    <span>Email:</span> aadigitalsmarketing@gmail.com
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="footer-bottom">
            <div className="container">
                <div className="d-md-flex align-items-center justify-content-between">
                    <ul className="footer-menu order-md-2">
                        <li><a href="#">Terms & Conditions</a></li>
                        <li><a href="#">Refund Policy</a></li>
                        <li><a href="#">Support</a></li>
                    </ul>
                    <p className="copyright-text order-md-1">Copyright By@ AA_Digitals - 2024</p>
                </div>
            </div>
        </div>
    </footer>
    )
}
export default Footer;